module.exports = __webpack_public_path__ + "img/cardNo.380459bd.png";